import type { RouterOutputs } from '@client/trpc/client';
import { TASK_DUE_DATE_SETTINGS, TASK_STATUSES, TASK_STATUSES_LABELS } from '@shared/constants';
import { differenceInBusinessDays } from '@shared/utils';

export function getTaskStatus({
    dueDate,
    isCompleted,
}: Pick<RouterOutputs['task']['getTask'], 'dueDate' | 'isCompleted'>) {
    if (isCompleted) {
        return TASK_STATUSES.DONE;
    }

    if (!dueDate) {
        return TASK_STATUSES.NOT_APPLICABLE;
    }

    const diffInDays = differenceInBusinessDays(dueDate, new Date());

    /*
     * Notes:
     *  Overdue = due today or in the past,
     *  Due soon = due tomorrow or up to 3 days in the future,
     *  Not due = due in more than 3 days
     */
    const status =
        diffInDays < 1
            ? TASK_STATUSES.OVERDUE
            : diffInDays <= TASK_DUE_DATE_SETTINGS.DUE_SOON_DAYS_COUNT
              ? TASK_STATUSES.DUE_SOON
              : TASK_STATUSES.NOT_DUE;

    return status;
}

export function getTaskStatusUI(task: Pick<RouterOutputs['task']['getTask'], 'dueDate' | 'isCompleted'>) {
    const TASK_STATUS_COLORS = {
        NOT_APPLICABLE: 'volcano',
        OVERDUE: 'red',
        DUE_SOON: 'orange',
        NOT_DUE: 'green',
        DONE: 'gray',
    } as const satisfies Record<keyof typeof TASK_STATUSES, string>;

    const status = getTaskStatus(task);

    return {
        label: TASK_STATUSES_LABELS[status],
        color: TASK_STATUS_COLORS[status],
    };
}
